import { Container, Typography, Box } from "@mui/material";
const Policies = () => {
  return (
    <Container maxWidth='md' sx={{ mt: 5, mb: 5 }}>
      <Typography
        variant='h4'
        align='center'
        gutterBottom
        sx={{ fontWeight: "bold", mb: 4 }}
      >
        Política de Privacidad
      </Typography>

      <Typography
        variant='body1'
        align='justify'
        gutterBottom
        sx={{ color: "#555", mb: 4 }}
      >
        En MerryColor, nos comprometemos a proteger tu privacidad. Esta política
        describe cómo recopilamos, usamos y protegemos tus datos personales, así
        como tus derechos sobre dicha información.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          1. Información que Recopilamos
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          Recopilamos información para proporcionar y mejorar nuestros
          servicios:
          <br />
          - <strong>Información personal:</strong> Nombre, correo electrónico,
          dirección y número de teléfono proporcionados al registrarte o realizar
          una compra.
          <br />
          - <strong>Datos de uso:</strong> Dirección IP, tipo de navegador y
          comportamiento de navegación en nuestro sitio.
          <br />- <strong>Datos de transacciones:</strong> Detalles sobre tus
          compras y preferencias de productos.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          2. Uso de la Información
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          Utilizamos tu información para los siguientes fines:
          <br />
          - Procesar pedidos y gestionar envíos.
          <br />
          - Personalizar tu experiencia y ofrecer contenido relevante.
          <br />
          - Enviar notificaciones sobre el estado de tus pedidos, promociones y
          actualizaciones del servicio.
          <br />- Cumplir con obligaciones legales y normativas.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          3. Servicios de Meta (Facebook/Instagram)
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          Aunque no utilizamos "Facebook Login" para la autenticación de
          usuarios, nuestra aplicación puede interactuar con los servicios de
          Meta para fines de publicidad, análisis o mensajería (WhatsApp/Messenger).
          <br />
          Cumplimos con las políticas de datos de Meta y garantizamos que cualquier
          dato compartido se utiliza estrictamente para los fines comerciales
          legítimos descritos.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          4. Compartir Información
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          No vendemos ni compartimos tus datos personales con terceros, excepto:
          <br />
          - Proveedores de servicios (envíos, pagos) necesarios para operar.
          <br />- Cuando sea requerido por ley o autoridades competentes.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          5. Protección de la Información
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          Implementamos medidas de seguridad técnicas y organizativas para proteger
          tus datos. Sin embargo, ninguna transmisión por internet es 100% segura,
          por lo que te recomendamos proteger tus credenciales de acceso.
        </Typography>
      </Box>

      <Box sx={{ mb: 4, bgcolor: "#f9f9f9", p: 2, borderRadius: 2 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          6. Instrucciones para la Eliminación de Datos
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          De acuerdo con las normas de privacidad y las políticas de la Plataforma
          de Meta, tienes derecho a solicitar la eliminación de tus datos
          personales almacenados en nuestros servidores.
          <br />
          <br />
          <strong>Para solicitar la eliminación de sus datos:</strong>
          <br />
          1. Envía un correo electrónico a{" "}
          <strong>merrycolor.oficial@gmail.com</strong> con el asunto "Solicitud
          de Eliminación de Datos".
          <br />
          2. Incluye tu nombre y el correo electrónico/teléfono asociado a tu
          cuenta.
          <br />
          3. Procesaremos tu solicitud en un plazo máximo de 30 días y te
          confirmaremos cuando tus datos hayan sido eliminados.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          7. Cambios en esta Política
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          Podemos actualizar esta política ocasionalmente. La versión más reciente
          estará siempre disponible en esta página.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant='h6' sx={{ fontWeight: "bold", mb: 1 }}>
          8. Contacto
        </Typography>
        <Typography variant='body2' sx={{ color: "#555" }}>
          Si tienes dudas sobre esta política, contáctanos en{" "}
          <strong>merrycolor.oficial@gmail.com</strong>.
        </Typography>
      </Box>
    </Container>
  );
};

export default Policies;
